import React from 'react';
import { setTheme, themes } from '../utils/themeUtils';
import './ThemeDemo.css';

const ThemeDemo: React.FC = () => {
  const handleThemeChange = (themeName: string) => {
    setTheme(themeName);
  };

  return (
    <div className="theme-demo">
      <h2>Dynamic Theme Demo</h2>
      <p>Click on any project to see the theme change:</p>
      
      <div className="theme-buttons">
        {Object.keys(themes).map((themeName) => (
          <button
            key={themeName}
            className="theme-button"
            style={{ 
              backgroundColor: themes[themeName].primary,
              color: themes[themeName].primary === '#ffffff' ? '#333' : '#fff'
            }}
            onClick={() => handleThemeChange(themeName)}
          >
            {themeName.charAt(0).toUpperCase() + themeName.slice(1)}
          </button>
        ))}
      </div>

      <div className="theme-preview">
        <div className="preview-card">
          <h3 style={{ color: 'var(--theme-primary)' }}>Current Theme</h3>
          <p style={{ color: 'var(--theme-text)' }}>
            This text uses the theme text color
          </p>
          <p style={{ color: 'var(--theme-text-light)' }}>
            This text uses the theme light text color
          </p>
          <div 
            className="color-swatch" 
            style={{ backgroundColor: 'var(--theme-primary)' }}
          >
            Primary Color
          </div>
          <div 
            className="color-swatch" 
            style={{ backgroundColor: 'var(--theme-secondary)' }}
          >
            Secondary Color
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThemeDemo;
